import './root.css'
import logo from 'url:./logo.png'

export { logo }
